"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openFilePicker = exports.onFilePicked = exports.createElement = exports.toBase64 = exports.isFile = void 0;
const tslib_1 = require("tslib");
const isFile = (input) => {
    return Object.prototype.toString.call(input) === "[object File]";
};
exports.isFile = isFile;
const toBase64 = (file) => {
    return new Promise((resolve) => {
        const fileReader = new FileReader();
        fileReader.addEventListener("load", (ev) => {
            var _a;
            resolve((_a = ev === null || ev === void 0 ? void 0 : ev.target) === null || _a === void 0 ? void 0 : _a.result);
        });
        fileReader.readAsDataURL(file);
    });
};
exports.toBase64 = toBase64;
// export interface
const createElement = (tag, attrs = {}) => {
    const el = document.createElement(tag);
    Object.entries(attrs).forEach(([attr, value]) => {
        el.setAttribute(attr, value);
        if (attr.startsWith("on")) {
            el.addEventListener(attr.substring(2), value);
        }
    });
    return el;
};
exports.createElement = createElement;
const onFilePicked = (e, config, callback) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const images = yield Promise.all([...e.target.files].map((file) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
        return ({
            file,
            src: config.base64 ? yield (0, exports.toBase64)(file) : URL.createObjectURL(file),
        });
    })));
    callback(config.multiple ? images : images[0]);
});
exports.onFilePicked = onFilePicked;
const openFilePicker = (config = {}, callback) => {
    const { type = "file", multiple = false, accept = "image/x-png,image/gif,image/jpeg", } = config;
    (0, exports.createElement)("input", {
        type,
        accept,
        multiple,
        onchange: (e) => {
            (0, exports.onFilePicked)(e, config, callback);
        },
    }).click();
};
exports.openFilePicker = openFilePicker;
